import React from 'react';
import { makeStyles } from '@mui/styles';
import ComplaintForm from './ComplaintForm';
import Feedback from '../../NewUDHome/Forms/Feedback';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    width: '100%',
    margin: 'auto', 
    marginTop: theme.spacing(4), 
    justifyContent: 'space-around',
    flexWrap: 'wrap'
  },
  imageContainer: {
    marginLeft: '5%',
    width: '45%',
    height: '520px',
    background: 'url(https://i.imgur.com/5k0HbLm.png)',
    objectFit: 'cover',
    backgroundPosition: 'center',
    backgroundSize: 'contain',
  },
}));

const FeedbackComplaint = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.imageContainer}></div>
      {/* <ComplaintForm /> */}
      <Feedback isTCP />
    </div>
  );
};

export default FeedbackComplaint;
